module.exports = __webpack_public_path__ + "img/ic_mpe_bed_sm1_normal.fb22da94.png";